import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'tg_utm';

/**
 * Captures UTM params from URL on first visit and persists in sessionStorage.
 * Returns the stored UTM object (or empty obj if none).
 */
export function useUtmCapture() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utm = {};
    let hasUtm = false;
    UTM_KEYS.forEach(key => {
      const val = params.get(key);
      if (val) {
        utm[key] = val;
        hasUtm = true;
      }
    });
    if (hasUtm) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    }
  }, [location.search]);
}

/**
 * Returns the current UTM attribution data from sessionStorage.
 */
export function getUtmData() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
